export const dataBiAreaAttribute = "data-bi-area";

// @ngInject
export let fillBiSlotDirective = function () {
  let slotsByAreaAndScope: { [scopeId: number]: { [areaName: string]: number } } = {};
  return {
    restrict: "A",
    link: function (scope: ng.IScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {
      let closestBiArea = element.closest(`[${dataBiAreaAttribute}`);
      let areaScope: ng.IScope = (<any>closestBiArea).scope();
      if (areaScope) {
        let areaScopeId = areaScope.$id;
        let areaName = closestBiArea.attr(dataBiAreaAttribute);

        let scopePartition = slotsByAreaAndScope[areaScopeId];
        if (!scopePartition) {
          slotsByAreaAndScope[areaScopeId] = scopePartition = {};
        }

        let slotNumber = scopePartition[areaName];
        if (slotNumber == undefined) {
          slotNumber = 1;
        }

        element.attr("data-bi-slot", slotNumber.toString());
        scopePartition[areaName] = ++slotNumber;
      }
    }
  };
};
